<template>
    <div class="row">
        <div class="col-6 pr-0" style="border-right: 1px solid rgb(202, 202, 202);">
            <div class="list-group-item ga-item-toolbar text-left">
                <div class="d-flex justify-content-between align-content-center">
                    <span>Alumnos {{ alumnosOrigen.length }}</span>
                    <button class="btn btn-sm btn-light" @click="selectAll()">
                        Todos
                        <i class="fas fa-arrow-right ml-1"></i>
                    </button>
                </div>
            </div>
            <div class="gp-max-height-off gp-max-height">
                <div class="list-group-item" v-for="alumno in alumnosOrigen" :key="alumno.id">
                    <div class="estatus-alumno mb-2" :class="coloresEstatus(alumno.estatus_registro_academico)" v-if="alumno.estatus_registro_academico">
                        <small><strong>{{alumno.estatus_registro_academico}}</strong></small>
                    </div>
                    <div class="d-flex justify-content-between">
                        <span>{{ alumno.apellido_paterno }} {{ alumno.apellido_materno }} {{ alumno.nombres }}</span>

                        <small v-if="alumnoEnOtroGrupoInflexible(alumno)">Alumno en otro grupo inflexible (cambio de grupo)</small>

                        <div>
                            <button class="btn btn-sm btn-success" v-if="!alumnoEnDestino(alumno.id)" @click="addAlumnoDestino(alumno)">
                                <i class="fas fa-arrow-right"></i>
                            </button>

                            <i class="fas fa-check text-success p-2" v-if="alumnoEnDestino(alumno.id)"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-6 pl-0">
            <div class="ga-item-toolbar text-left">
                <div class="list-group-item d-flex justify-content-between align-content-center">
                    <span>{{ alumnosDestino.length }} Alumnos</span>
                    <button class="btn btn-sm btn-light" @click="removeAll()">
                        <i class="fas fa-trash mr-1"></i>
                        Eliminar todos
                    </button>
                </div>
                <div class="gp-max-height-off gp-max-height">
                    <div class="list-group-item" v-for="alumno in alumnosDestino" :key="alumno.id">
                        <div class="estatus-alumno mb-2" :class="coloresEstatus(alumno.estatus_registro_academico)" v-if="alumno.estatus_registro_academico">
                            <small><strong>{{alumno.estatus_registro_academico}}</strong></small>
                        </div>
                        <div class="d-flex justify-content-between">
                            <span>{{ alumno.apellido_paterno }} {{ alumno.apellido_materno }} {{ alumno.nombres }}</span>
                            <button class="btn btn-sm btn-danger" @click="removeAlumnoDestino(alumno)">
                                <i class="fas fa-trash"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import alumnos from '../../../api/requests/alumno'
export default {
    name: 'AlumnosEditList',
    props: ['alumnosOrigen', 'alumnosDestino'],
    inject: ['selectedGrupoChange$', 'selectedCicloChange$'],
    data() {
        return {
            grupoToSave: {},
            cicloToSave: {},
            alumnosSave: new Set(),
            alumnosDelete: new Set(),
            estatusBaja: []
        }
    },
    mounted() {
        this.selectedGrupoChange$.subscribe(grupo => this.grupoToSave = grupo);
        this.selectedCicloChange$.subscribe(ciclo => this.cicloToSave = ciclo);
    },
    created(){
        this.getEstatusAlumno()
    },
    methods: {
        async getEstatusAlumno(){
            try{
                const params = {
                    type: 'baja'
                }
                const {data: response} = await alumnos.getEstatusAlumno(params)
                response.map(r =>{
                    this.estatusBaja.push(r.status)
                })
            }catch(error){
                console.error(error)
            }
        },
        coloresEstatus(estatus){
            if(['Inscrito económico','Reactivación'].includes(estatus)){
                return 'col-green'
            }else if(['Congelado'].includes(estatus)){
                return 'col-yellow'
            }else if(this.estatusBaja.includes(estatus)){
                return 'col-red'
            }else{
                return 'col-blue'
            }
        },
        alumnoEnDestino(alumnoId) {
            return this.alumnosDestino.some(alumno => alumno.id == alumnoId);
        },
        removeAlumnoDestino(alumno) {
            const index = this.alumnosDestino.indexOf(alumno);

            if (index > -1) {
              this.alumnosDestino.splice(index, 1);
              this.alumnosDelete.add(alumno);
              this.alumnosSave.delete(alumno);
              this.raiseAlumnosDestinoChange();
            }
        },
        addAlumnoDestino(alumno) {
            this.alumnosDestino.push(alumno);
            this.alumnosSave.add(alumno);
            this.alumnosDelete.delete(alumno);
            this.raiseAlumnosDestinoChange();
        },
        selectAll() {
          this.alumnosOrigen.forEach(a => {
            if (!this.alumnoEnDestino(a.id)) {
              this.alumnosSave.add(a);
              this.alumnosDestino.push(a);
            }
          });

          this.alumnosDelete.clear();
          this.raiseAlumnosDestinoChange();
        },
        removeAll() {
          while (this.alumnosDestino.length > 0) {
            this.alumnosDelete.add(this.alumnosDestino[0]);
            this.alumnosDestino.splice(0, 1);
          }

          this.alumnosSave.clear();
          this.raiseAlumnosDestinoChange();
        },
        alumnoEnOtroGrupoInflexible(alumno) {
            if (this.grupoToSave.flexible) {
                return false;
            }

            return alumno.grupos_administrativos.some(g => g.ciclo_escolar_id == this.cicloToSave.id && !g.grupo.flexible);
        },
        raiseAlumnosDestinoChange() {
          this.$emit('alumnosDestinoChange', {
            alumnosSave: this.alumnosSave,
            alumnosDelete: this.alumnosDelete,
          });
        }
    }
}
</script>



<style lang="scss" scoped>
    .estatus-alumno{
        display:inline-block;
        // background-color: #007BFF;
        // color:#ffff;
        padding: 3px 15px;
        border-radius: 7px;
        text-transform: uppercase;
    }
    .col-yellow{
        background: rgb(255, 248, 236);
        color: #febf3d;
    }
    .col-yellow{
        background: rgb(255, 248, 236);
        color: #febf3d;
    }

    .col-red{
        color: #f62d51;
        background: rgb(249, 231, 235);
    }

    .col-green{
        color: #55ce63;
        background: rgb(232, 253, 235);
    }

    .col-purple{
        color: purple;
        background: rgb(232, 218, 239);
    }

    .col-blue{
        color: #2874A6;
        background: rgb(214, 234, 248);
    }

    .col-gray{
        color: #5F6A6A;
        background: rgb(242, 243, 244);
    }

    .col-pink{
        color: #F08080;
        background: rgb(255, 236, 236);
    }

    .col-brown{
        color: #784212;
        background: rgb(250, 229, 211);
    }
</style>
